import React, {useCallback, useEffect, useState} from 'react'
import {Formik, Field, Form} from 'formik'
import {useToggle} from 'lib/hooks'
import {Modal, Button, Box, TextArea} from 'components'
import useCustomTranslation from 'lib/customT'
import TransWrapper from 'lib/transWrapper'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import { getPaymentImages, getIsFetchingImages } from 'payments/selectors'
import { getActive } from 'clubs'
import imageToBase64 from 'lib/imageToBase64'
import { uploadImage, fetchImages, deleteImage, updatePayer, resetPayerStatus} from 'payments/actions'
import PaymentImages from '../PaymentImages'

const RemoveWithNoteButton = ({
  approve,
  memberId,
  userPaymentId,
  status,
  payers,
  paymentImages,
  activeClub,
  isFetchingImages,
  fetchImages,
  deleteImage,
  uploadImage,
  handleRemove,
  updatePayer,
  id,
  paymentId,
  resetPayerStatus,
  ...props
}) => {
  const t = useCustomTranslation()
  const [isOpen, open, close] = useToggle()
  const [paymentNote, setPaymentNote] = useState("")


  const handleSubmit = async (values) => {
    if(values.images !== null && values.images.length > 0 && values.images[0]){
      new Promise(async (resolve, reject) => {
        const base64String = await imageToBase64(values.images[0])

        uploadImage({
          resolve, reject, 
          entityId: userPaymentId,
          entityType: 17,
          base64String: base64String,
          fileName: values.images[0].name,
          clubId: activeClub.id
         })
         if(status === 3 || status === 5){
          resetPayerStatus({ userPaymentId })
         } else {
          handleRemove(memberId)
         }
         updatePayer({values, resolve, reject})
      }).then(close);
    } else {
      new Promise((resolve, reject) => {
        if(status === 3 || status === 8 || status === 9){
          resetPayerStatus({ userPaymentId })
         } else {
          handleRemove(memberId)
         }
        updatePayer({values, resolve, reject})
      }).then(close);
    }
  }

  useEffect(()=>{
    payers.forEach((payer)=> {
      if(payer.id === userPaymentId){
        setPaymentNote(payer.internalNote)
      }
    })
  }, [payers])

  useEffect(()=>{
    if(isOpen){
      new Promise((resolve, reject) => {
       fetchImages({resolve, reject, entityId: userPaymentId, entityType: 17})
      })
    }
  }, [isOpen])

  if (isFetchingImages) {
    return (
    <Button onClick={open} {...props}>
      {t('Godkend')}
    </Button>
    )
  } else {
  return (
    <>
      {isOpen && (
        <Modal title={`${t('Annuller betaling')}`} hide={close}>
          <Box p={3}>
            <Formik onSubmit={handleSubmit} initialValues={{internalNote: paymentNote, images: "", memberId: memberId, paymentId: paymentId }}>
            {({ values, setFieldValue }) => (
              <Form>
                <Field
                  
                  name="internalNote"
                  component={TextArea}
                  placeholder={`${t('Note')}...`}
                  mb={3}
                />
                <PaymentImages
                  setFieldValue={setFieldValue}
                  value={values.images}
                  id={values.id}
                  paymentImages={paymentImages}
                  deleteFn={deleteImage}
                />
              
                <Button small block type="submit" >
                  {t('Annuller')}
                </Button>
              </Form>
            )}
            </Formik>
          </Box>
        </Modal>
      )}
      <Button onClick={open} {...props}>
        {t('Annuller')}
      </Button>
    </>
  )}
}

const enhancer = connect(
  createStructuredSelector({
    paymentImages: getPaymentImages,
    activeClub: getActive,
    isFetchingImages: getIsFetchingImages
  }),{
    uploadImage: uploadImage.requested,
    fetchImages: fetchImages.requested,
    deleteImage: deleteImage.requested,
    updatePayer: updatePayer.requested,
    resetPayerStatus: resetPayerStatus.requested
  }
)

export default enhancer(RemoveWithNoteButton)